import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaFilePdf } from "react-icons/fa";

export default function CourseCalender () {
  const [viewData, setViewData] = useState([]);
  useEffect(() => {
    try {
      const url = `${process.env.REACT_APP_API}/course/calender`;
      axios
        .get(url)
        .then((res) => {
          setViewData(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);
  return (
      <div className="flex flex-col items-center justify-center py-3">
        <h1 className="font-bold text-xl py-2 text-center">Course Calendar</h1>
        <tbody className="rounded-md">
          <tr>
            <th>S.No</th>
            <th>Course Name</th>
            {/* <th>Course Id</th>
            <th>Course No.</th>
            <th>Course Code</th>
            <th>Course Officer</th>
            <th>Course Faculty</th>
            <th>Course Mode</th>
            <th>Course Type</th>
            <th>Eligiblity</th>
            <th>Course Duration</th>
            <th>Course Fee</th>
            <th>Course Capacity</th> */}
            <th>Course Start Date</th>
            <th>Course Completion Date</th>
            <th>Last Date Apply</th>
            <th>Brochure</th>
          </tr>
          {viewData.map((data, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{data.course_title}</td>
                {/* <td>{data.course_id}</td>
                <td>{data.course_no}</td>
                <td>{data.course_code}</td>
                <td>{data.course_director}</td>
                <td>{data.faculty}</td>
                <td>{data.course_mode}</td>
                <td>{data.course_type}</td>
                <td>{data.eligibility}</td>
                <td>{data.course_duration}</td>
                <td>{data.fee}</td>
                <td>{data.course_capacity}</td> */}
                <td>{data.start_date}</td>
                <td>{data.completion_date}</td>
                <td>{data.completion_date}</td>
                <td className="cursor-pointer text-center flex justify-center"><FaFilePdf className="text-xl text-red-500"/></td>
              </tr>
            );
          })}
        </tbody>
      </div>
  );
}
